import { createFileRoute } from "@tanstack/react-router";
import { PortalChangesPage } from "@/features/changes/PortalChangesPage";
import { PortalFrame } from "@/features/portal-home/PortalFrame";

/** Change requests the agency sent the client, inside the portal frame so the client keeps the navigation. */
export const Route = createFileRoute("/portal/changes")({ component: PortalChangesRoute });

function PortalChangesRoute() {
  return (
    <PortalFrame>
      <PortalChangesPage />
    </PortalFrame>
  );
}
